module.exports = __webpack_public_path__ + "static/img/friendly_links.a4069c6d.png";